import { createBrowserRouter } from "react-router-dom";
import { LoginPage } from "../pages/login/ui/LoginPage/LoginPage";
import { AutorizationPage } from "../pages/autorization";
import { RegistrationPage } from "../pages/registration";
import { ResetPasswordPage } from "../pages/resetPassword";
import { ProtectendRoute } from "@src/shared/components/ProtectendRoute/ProtectendRoute";
import { MainLayout, MainPage } from "@src/pages/main";
import { SelectTariff } from "@src/pages/selectTariff";
import { PersonalCabinet } from "@src/pages/personalCabinet";
import { AccountDeletionPage } from "@src/pages/accountDeletion";
import { ChangePasswordPage } from "@src/pages/сhangePassword";
import { SearchHistory } from "@src/pages/searchHistory/SearchHistory";
import { CreatingSearchRequestHH } from "@src/pages/creatingSearchRequestHH";
import { CandidatePage } from "@src/pages/candidate/CandidatePage";
import { HelperUsingTool } from "@src/pages/helperUsingTool";
import { AccountMigrationPage } from "@src/pages/accountMigration";
import { StubPage } from "@src/pages/stub";
import { RegistrationSuccessPage } from "@src/pages/registrationSuccess";
import { YandexAutorizationPage } from "@src/pages/yandexAutorization";
import { AuthErrorPage } from "@src/pages/authErrorPage";
import { FeedbackPage } from "@src/pages/feedback";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectendRoute>
        <MainLayout />
      </ProtectendRoute>
    ),
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: "/select-tariff",
        element: <SelectTariff />,
      },
      {
        path: "/personal-cab",
        element: <PersonalCabinet />,
      },
      {
        path: "/account-deletion",
        element: <AccountDeletionPage />,
      },
      {
        path: "/change-password",
        element: <ChangePasswordPage />,
      },
      {
        path: "/search-history",
        element: <SearchHistory />,
      },
      {
        path: "/creating-search",
        element: <CreatingSearchRequestHH />,
      },
      {
        path: "/change-search-query",
        element: <CreatingSearchRequestHH />,
      },
      {
        path: "/candidate",
        element: <CandidatePage />,
      },
      {
        path: "/helper-tool",
        element: <HelperUsingTool />,
      },
      {
        path: "/feedback",
        element: <FeedbackPage />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/autorization",
    element: <AutorizationPage />,
  },
  {
    path: "/registration",
    element: <RegistrationPage />,
  },
  {
    path: "/resetPassword",
    element: <ResetPasswordPage />,
  },
  {
    path: "/account-migration",
    element: <AccountMigrationPage />,
  },
  {
    path: "/stub",
    element: <StubPage />,
  },
  {
    path: "/registration-success",
    element: <RegistrationSuccessPage />,
  },
  {
    path: "/auth/succces",
    element: <YandexAutorizationPage />,
  },
  {
    path: "/auth/error",
    element: <AuthErrorPage />,
  },
  {
    path: "/*",
    element: <div>Страница не найдена</div>,
  },
]);
